<template>
  <d-modal v-if="visible" @close="close" size="lg" :no-backdrop="true">
    <d-modal-header>
      <d-modal-title>Orçamentos - {{ sellerName }}</d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0 pb-3">
      <div class="table-overflow">
        <report-quotation-table :reports="quotations"></report-quotation-table>
      </div>
      <pagination
        :total-items="totalItems"
        :pagination.sync="pagination"
        event-name="update:seller-quotations-pagination"
      ></pagination>
    </d-modal-body>
  </d-modal>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import ReportService from '_services/rest/modules/report';
import ReportQuotationTable from './ReportQuotationTable.vue';

export default {
  name: 'report-seller-quotations-modal',
  components: {
    Pagination,
    ReportQuotationTable,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    seller: {
      type: Object,
      default: null,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      quotations: [],
      totalItems: 0,
      pagination: {
        skip: 0,
        take: 10,
        page: 1,
      },
    };
  },
  computed: {
    sellerName() {
      return this.seller ? this.seller.name : '';
    },
    requestFilters() {
      const sellerId = this.seller ? this.seller.id : null;
      return {
        ...this.filters,
        bySeller: sellerId,
      };
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) {
          this.resetPagination();
          this.getList();
        }
      },
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.clearList();
      this.$emit('close');
    },
    resetPagination() {
      this.pagination = {
        skip: 0,
        take: 10,
        page: 1,
      };
    },
    onPaginationUpdate(pagination) {
      this.pagination = pagination;
      this.getList();
    },
    getList() {
      const sellerId = this.seller ? this.seller.id : null;

      this.setToggle({ type: 'progress', bool: true });
      ReportService.getReportQuotationList({
        ...this.pagination,
        filters: this.requestFilters,
      })
        .then(response => {
          if (!this.visible || !this.seller || this.seller.id !== sellerId) {
            return;
          }
          this.quotations = response.list || [];
          this.totalItems = response.total_items || 0;
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    clearList() {
      this.quotations = [];
      this.totalItems = 0;
    },
  },
  mounted() {
    this.clearList();
    Events.$on('update:seller-quotations-pagination', this.onPaginationUpdate);
  },
  beforeDestroy() {
    Events.$off('update:seller-quotations-pagination', this.onPaginationUpdate);
    this.clearList();
  },
};
</script>

<style lang="scss" scoped>
.table-overflow {
  min-height: 20vh;
}

.modal {
  z-index: 1090;

  &--no-backdrop {
    background-color: rgba(0, 0, 0, 0.5) !important;
    pointer-events: auto !important;
  }
}

@media (min-width: 992px) {
  .modal ::v-deep .modal-lg {
    width: 95vw;
    max-width: 1400px;
  }
}
</style>
